import { CALENDER_PREFERENCES } from 'resources/Organization/Employee/CalendarPreference/Data';
import { PRO_NAMESPACE, PROS_NAMESPACE } from 'resources/Pro/ProData';

import { INVOICE_QUERY_KEYS } from 'components/Account/DefaultInvoiceSettings/common/invoiceQueryCacheKeys';
import { QUERY_KEYS as CHECK_REVIEW_QUERY_KEYS } from 'components/AdminNew/CheckReview/common/queryCacheKeys';
import { ESTIMATE_QUERY_KEYS } from 'components/Estimate/common/estimateQueryCacheKeys';
import { ACCOUNTING_QUERY_KEYS } from 'components/MyMoneyV2/Accounting/helpers/accountingQueryCacheKeys';
import { PAYROLL_QUERY_KEYS } from 'components/MyMoneyV2/Payroll/payrollQueryCacheKeys';
import { UNIFIED_ONBOARDING_KEYS } from 'components/OnlineBookingOnboarding/unifiedOnboardingCacheKeys';

export const cacheQueryKeys = {
  Estimate: ESTIMATE_QUERY_KEYS,
  Invoice: INVOICE_QUERY_KEYS,
  Pros: PROS_NAMESPACE,
  Pro: PRO_NAMESPACE,
  CalendarPreferences: CALENDER_PREFERENCES,
  UnifiedOnboarding: UNIFIED_ONBOARDING_KEYS,
  UnscheduledJobs: 'unscheduledJobs',
  UnscheduledJobsCount: 'unscheduledJobsCount',
  JobsList: 'jobsList',
  JobFieldsConfigurationApi: 'jobFieldsConfigurationApi',
  orgFranchisees: 'orgFranchisees',
  CalendarItem: 'calendarItem',
  BusinessHours: 'businessHours',
  CallFlowsSettings: 'callFlowsSettings',
  CallRoutes: 'callRoutes',
  GlobalSearch: 'globalSearch',
  ServiceZone: 'serviceZone',
  ServiceZoneFeatureFlag: 'serviceZone',
  Organization: 'organization',
  EstimatesReporting: 'estimatesReporting',
  EstimatesReportingTotalRow: 'estimatesReportingTotalRow',
  MaterialsReporting: 'materialsReporting',
  ShowEmployee: 'showEmployee',
  MaterialsUsage: 'materialsUsage',
  LeadData: 'leadData',
  LeadAttachments: 'LeadAttachments',
  Employees: 'employees',
  BetaEstimatesIndex: 'betaEstimatesIndex',
  LeadsReporting: 'leadsReporting',
  LeadsReportingTotalRow: 'leadsReportingTotalRow',
  UpsellsReporting: 'upsellsReporting',
  UpsellsReportingTotalRow: 'upsellsReportingTotalRow',
  ServicePlansReporting: 'servicePlansReporting',
  ServicePlansReportingTotalRow: 'servicePlansReportingTotalRow',
  ServicePlanVisits: 'servicePlanVisits',
  CustomerServicePlanInvoices: 'customerServicePlanInvoices',
  VoiceReporting: 'voiceReporting',
  VoiceReportingTotalRow: 'voiceReportingTotalRow',
  Tags: 'tags',
  CommmissionsEnabled: 'commmissionsEnabled',
  Accounting: ACCOUNTING_QUERY_KEYS,
  AvailableTags: 'availableTags',
  AvailableServices: 'availableServices',
  AvailablePublicServices: 'availablePublicServices',
  OnlineBookingTimeSlots: 'onlineBookingTimeSlots',
  OnlineBookingServiceInfo: 'onlineBookingServiceInfo',
  PublicOrgData: 'publicOrgData',
  EmployeeTags: 'employeeTags',
  Reminders: 'reminders',
  QuickbooksOnlineProcesses: 'quickbooksOnlineProcesses',
  TwoFactorAuthGetPermissions: 'twoFactorAuthGetPermissions',
  JobLineItems: 'jobLineItems',
  JobLineItemsExperiment: 'jobLineItemsExperiment',
  IndexJobInputMaterials: 'indexJobInputMaterials',
  IndexJobInputMiscellaneous: 'indexJobInputMiscellaneous',
  Customer: 'customer',
  BookingHours: 'bookingHours',
  EarliestAvailability: 'earliestAvailability',
  arrivalWindow: 'arrivalWindow',
  EmployeeDefaultPermissionsDetails: 'employeeDefaultPermissionsDetails',
  JobLineItemDetailsSetting: 'jobLineItemDetailsSetting',
  OnlineBookingHoursDeprecated: 'onlineBookingHoursDeprecated',
  Payroll: PAYROLL_QUERY_KEYS,
  JobDetailsCostingSettings: 'jobDetailsCostingSettings',
  RecommendedActions: 'recommendedActions',
  OpeningHours: 'openingHours',
  CheckReview: CHECK_REVIEW_QUERY_KEYS,
  LaborCostSettings: 'laborCostSettings',
  JobCosting: 'jobCosting',
  SmsDetails: 'smsDetails',
  EmployeePaySettings: 'employeePaySettings',
  OrganizationAlpha: 'organizationAlpha',
  LineItemSuggestions: 'lineItemSuggestions',
  DeletedCustomersList: 'deletedCustomersList',
  PaywallPlanData: 'paywallPlanData',
  CreateHCPEmployee: 'createHCPEmployee',
  ExpenseCardsReceiptAttachments: 'expenseCardsReceiptAttachments',
  EmployeesForJobDetails: 'employeesForJobDetails',
};

export default cacheQueryKeys;
